import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import CheckoutHeader from "../shared/CheckoutHeader";
import LoadingScreen from "../shared/LoadingScreen";
import CheckoutFooter from "../shared/CheckoutFooter";
import PaymentDetails from "../PaymentDetails";
import { DojoCheckout } from "../../../../components/dojo";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const getNumericAmount = (value) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : null;
};

const PaymentLandingPage = () => {
  const [isFinalLoading, setFinalLoading] = useState(true);
  const location = useLocation();

  const restaurantDetail = useSelector(
    (state) => state.restaurantData?.restaurantDetail
  );
  const orderData = location.state?.orderData ?? null;
  const paymentAmount =
    getNumericAmount(orderData?.remainingToPay) ??
    getNumericAmount(orderData?.totalAmount);

  // Get payment gateway setting
  const paymentGateway = restaurantDetail?.paymentSettings?.tableOrder?.defaultGateway ?? 'stripe';

  return (
    <Container
      className={"device-width"}
      sx={{
        px: "0 !important",
        backgroundColor: "#f9f9f9",
        height: "100vh",
        maxHeight: "100vh",
        overflow: "auto",
        pb: 10,
      }}
    >
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 5,
        }}
      >
        <CheckoutHeader />
      </Box>

      {isFinalLoading && (
        <Box sx={{ position: "relative", top: "-8%" }}>
          <LoadingScreen />
        </Box>
      )}

      <Box
        sx={{
          visibility: !isFinalLoading ? "visible" : "hidden",
          opacity: !isFinalLoading ? 1 : 0,
          transition: "opacity 1s ease-in, visibility 0s linear 1s",
        }}
      >
           {paymentGateway === 'stripe' && (
          <PaymentDetails
            setFinalLoading={setFinalLoading}
            isFinalLoading={isFinalLoading}
            paymentAmount={paymentAmount}
          />
        )}
        {paymentGateway === 'dojo' && (
          <DojoCheckout
            setFinalLoading={setFinalLoading}
            isFinalLoading={isFinalLoading}
            paymentAmount={paymentAmount}
          />
        )}
        {paymentGateway === 'direct' && (
          // Handle direct payment case - maybe redirect or show message
          <Box>Direct payment is handled elsewhere</Box>
        )}
        <CheckoutFooter />
      </Box>
    </Container>
  );
};

export default PaymentLandingPage;
